/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2018-2-1
 *    
 */
// import T from 'dolphin-lake';
import leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './leaflet.css';
import '@/Polyfill';
import Map from '@/Map';
//
import { wgs84togcj02, gcj02towgs84 } from '@/utils/coordtransform';
//
// 注册 leaflet 模块，amd
T.declare({ leaflet });
// 
var L = T.leaflet = {};
//
L.Map = Map;
L.map = (node, options) => new Map(node, options);
L.wgs84togcj02 = wgs84togcj02;
L.gcj02towgs84 = gcj02towgs84;
//
export default L;


// WEBPACK FOOTER //
// ./entry/leaflet.js